import { cn } from '@/lib/utils';
import React from 'react';
import { SeverityEnum } from './enums/severity';

const severityColorClasses: Record<SeverityEnum, string> = {
  error: 'bg-red-50 text-red-700 ring-1 ring-inset ring-red-200',
  warning: 'bg-yellow-50 text-yellow-700 ring-1 ring-inset ring-yellow-200',
  success: 'bg-green-50 text-green-700 ring-1 ring-inset ring-green-200',
  info: 'bg-blue-50 text-blue-700 ring-1 ring-inset ring-blue-200',
  note: 'bg-gray-50 text-gray-700 ring-1 ring-inset ring-gray-200',
};

interface StatusBadgeProps {
  status: string;
  severity: SeverityEnum;
  square?: boolean;
  className?: string;
}

export const StatusBadge: React.FC<StatusBadgeProps> = ({
  status,
  severity,
  square = false,
  className = '',
}) => (
  <span
    className={cn(
      'inline-flex items-center',
      'px-2 py-0.5',
      'text-xs font-medium',
      square ? 'rounded-md' : 'rounded-full',
      severityColorClasses[severity],
      className
    )}
  >
    {status}
  </span>
);
